import { c as _c } from "react/compiler-runtime";
import { createContext, type ReactNode, useContext, useState } from 'react';

// Bridges the docked sidebar slot to the ChatWidget: the slot registers its DOM
// node, the widget portals into it. A full-page surface that covers the layout
// (e.g. the agent builder's fixed overlay) registers an override slot, which wins
// while mounted; ref callbacks self-clean, so the base slot takes back over.
// The fullscreen slot is a separate channel: a target overlaying the content card
// that the widget portals onto when fullscreen, so the browser keeps it sized to
// the content area (vs. the old hand-synced fixed overlay).
type ChatWidgetSlotContextValue = {
  slotEl: HTMLElement | null;
  setSlotEl: (el: HTMLElement | null) => void;
  setOverrideSlotEl: (el: HTMLElement | null) => void;
  hasOverride: boolean;
  fullscreenSlotEl: HTMLElement | null;
  setFullscreenSlotEl: (el: HTMLElement | null) => void;
};
const ChatWidgetSlotContext = createContext<ChatWidgetSlotContextValue | null>(null);
export const ChatWidgetSlotProvider = t0 => {
  const $ = _c(7);
  const {
    children
  } = t0;
  const [baseEl, setSlotEl] = useState(null);
  const [overrideEl, setOverrideSlotEl] = useState(null);
  const [fullscreenSlotEl, setFullscreenSlotEl] = useState(null);
  const t1 = overrideEl ?? baseEl;
  const t2 = overrideEl != null;
  let t3;
  if ($[0] !== fullscreenSlotEl || $[1] !== t1 || $[2] !== t2) {
    t3 = {
      slotEl: t1,
      setSlotEl,
      setOverrideSlotEl,
      hasOverride: t2,
      fullscreenSlotEl,
      setFullscreenSlotEl
    };
    $[0] = fullscreenSlotEl;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const value = t3;
  let t4;
  if ($[4] !== children || $[5] !== value) {
    t4 = <ChatWidgetSlotContext.Provider value={value}>{children}</ChatWidgetSlotContext.Provider>;
    $[4] = children;
    $[5] = value;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export const useChatWidgetSlot = () => {
  return useContext(ChatWidgetSlotContext) ?? {
    slotEl: null,
    setSlotEl: _temp,
    setOverrideSlotEl: _temp2,
    hasOverride: false,
    fullscreenSlotEl: null,
    setFullscreenSlotEl: _temp3
  };
};
function _temp() {}
function _temp2() {}
function _temp3() {}